import type { MarketResponseBenchmark, MarketStatsField, MarketStatsSource } from "./types";

export type MarketStatsParseResult = {
  detectedSource?: MarketStatsSource;
  confidence: number;
  extractedFields: Partial<Record<MarketStatsField, number>>;
  warnings: string[];
};

export interface MarketStatsParser {
  readonly id: string;
  readonly available: boolean;
  parseScreenshot(file: File, source?: MarketStatsSource): Promise<MarketStatsParseResult>;
}

export interface MarketPortalStatsProvider {
  readonly id: string;
  readonly available: boolean;
  loadListingStats(externalListingId: string, capturedAt: string): Promise<MarketStatsParseResult>;
}

export type MarketBenchmarkQuery = {
  municipalityId?: string;
  propertyType: string;
  rooms?: string;
  dayFromListing: number;
};

export interface MarketBenchmarkRepository {
  findBenchmark(query: MarketBenchmarkQuery): Promise<MarketResponseBenchmark | null>;
}

export const unavailableScreenshotParser: MarketStatsParser = {
  id: "unavailable",
  available: false,
  async parseScreenshot(_file, source) {
    return {
      detectedSource: source,
      confidence: 0,
      extractedFields: {},
      warnings: ["Automatické čítanie screenshotu zatiaľ nie je pripojené. Hodnoty potvrď manuálne."]
    };
  }
};

export const unavailablePortalStatsProvider: MarketPortalStatsProvider = {
  id: "unavailable",
  available: false,
  async loadListingStats() {
    return { confidence: 0, extractedFields: {}, warnings: ["Portálové API zatiaľ nie je pripojené."] };
  }
};

export const emptyMarketBenchmarkRepository: MarketBenchmarkRepository = {
  async findBenchmark() { return null; }
};
